import { AdminApi } from 'stylemix-vue-admin'

export default class UsersApi extends AdminApi {
  constructor(parameters) {
    super('users', parameters)
  }
}
